import { motion } from "framer-motion"
import { Crown, Eye, Trophy, Zap } from "lucide-react"

const features = [
  {
    icon: Crown,
    title: "Prestige Collection",
    description: "We curate the most exclusive gold, diamond, and heirloom skins across all major titles. Only the rarest make our list.",
  },
  {
    icon: Eye,
    title: "Stand Out in the Lobby",
    description: "Find the most blinged-out cosmetics that turn heads before the match even starts. Style is the ultimate flex.",
  },
  {
    icon: Trophy,
    title: "Acquisition Guides",
    description: "Detailed tips on how to unlock, earn, or purchase every prestige skin. No guesswork, just results.",
  },
  {
    icon: Zap,
    title: "First to Know",
    description: "Stay ahead with instant coverage of new prestige skin releases, limited-time events, and exclusive drops.",
  },
]

export default function ValueProp() {
  return (
    <section id="value-prop" className="relative py-20 sm:py-28 bg-black/40">
      <div className="absolute inset-0 bg-gradient-to-b from-black via-transparent to-black pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight mb-4"
            style={{ fontFamily: "'Orbitron', sans-serif" }}
          >
            <span className="text-white">Why </span>
            <span className="gold-shimmer">BlingSkins?</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            We help gamers find the most blinged-out cosmetics to stand out in the lobby.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="card-lift group relative p-6 sm:p-8 rounded-2xl bg-gradient-to-b from-gray-900/80 to-gray-950/80 border border-gray-800/50 hover:border-yellow-700/40"
            >
              <div className="w-12 h-12 rounded-xl bg-yellow-500/10 border border-yellow-700/30 flex items-center justify-center mb-5 group-hover:bg-yellow-500/20 transition-colors">
                <feature.icon className="w-6 h-6 text-yellow-500" />
              </div>
              <h3
                className="text-lg font-bold text-white mb-3 uppercase tracking-wide"
                style={{ fontFamily: "'Orbitron', sans-serif", fontSize: "0.95rem" }}
              >
                {feature.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
